import React, { useState } from "react";
import Modal, { Content, Header } from "_c/Modals";
import PT from "prop-types";
import Calendar from "_c/Calendar";
import Label from "_c/form/Label";
import moment from "moment";
import isempty from "lodash/isEmpty";
import Empty from "_c/Empty";
import { useMasterFreeSlotsQuery } from "@/hooks/queries/useMasterFreeSlotsQuery";
import QueryRequest from "@/components/QueryRequest";

const Main = (props) => {
  const [date, setDate] = useState([moment().startOf("day").toDate()]);
  const query = useMasterFreeSlotsQuery(
    {
      masterId: props.masterId,
      date: date[0],
    },
    {
      staleTime: 0,
      enabled: Boolean(date[0] && props.masterId),
    }
  );
  const slots = query.data;
  return (
    <>
      <Header onClick={props.onClose}>{props.t("common:close")}</Header>
      <Content>
        <Label htmlFor="master-day-free-slots">{props.t("common:date")}</Label>
        <Calendar onChange={setDate} value={date} id="master-day-free-slots" />
        <div
          css={`
            margin-top: 15px;
            color: var(--font-color-main);
          `}
        >
          <QueryRequest query={query}>
            {isempty(slots) ? (
              <Empty message={props.t("common:empty_free_slots")} />
            ) : (
              <ul
                css={`
                  display: flex;
                  flex-wrap: wrap;
                  justify-content: flex-start;
                `}
              >
                {slots.map((slot, idx) => (
                  <li
                    css={`
                      background-color: var(--color-cta);
                      color: white;
                      padding: 10px;
                      border-radius: 7px;
                      margin: 3px;
                    `}
                    key={idx}
                  >
                    <span>{moment(slot.start).format("HH:mm")}</span>{" "}
                    <span>-</span>{" "}
                    <span>{moment(slot.end).format("HH:mm")}</span>
                  </li>
                ))}
              </ul>
            )}
          </QueryRequest>
        </div>
      </Content>
    </>
  );
};
const FreeSlotsModal = (props) => {
  return (
    <Modal onClose={props.onClose} isOpen={props.isOpen}>
      <Main t={props.t} masterId={props.masterId} onClose={props.onClose} />
    </Modal>
  );
};
FreeSlotsModal.propTypes = {
  masterId: PT.string,
  isOpen: PT.bool,

  t: PT.func.isRequired,
  onClose: PT.func.isRequired,
};

export default FreeSlotsModal;
